import { httpClientPrivate } from '@/libs/httpClient'
import { RequestDocumentHistoryListType } from './types'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'

const fetchRequestDocumentList = async (claimId: string) => {
  const response = await httpClientPrivate.get<RequestDocumentHistoryListType>(
    `${config.restUrl}/v1/backoffice/e-claim/${claimId}/request-document`,
  )

  return response.data
}

const useRequestDocumentList = (claimId: string) => {
  const queryKey = ['useRequestDocumentList', claimId]
  const queryFn = async () => fetchRequestDocumentList(claimId)

  const queryResult = useQuery({
    queryKey,
    queryFn,
    enabled: !!claimId, // Only run the query if claimId is provided
  })

  return { ...queryResult }
}

export { fetchRequestDocumentList, useRequestDocumentList }
